import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ApplicationUser } from '../../../../../../security/application-user.model';
import { UserAuthorizationService } from '../../../../../../security/services/user-authorization.service';
import { SharedToasterService } from '../../../../../../shared/services/shared-toaster.service';
import { AssignmentCommunicationFeedbackPostModel } from '../../../models/assignment-communication-feedback-post.model';
import { SportDisciplineLeaderModel } from '../../../models/assignments-communication/sport-discipline-leader.model';
import { AssignmentDetailsStateService } from '../../../services/assignment-details-state.service';
import { AssignmentsCommunicationStateService } from '../../../services/assignments-communication-state-service';
import { AssignmentsCommunicationService } from '../../../services/assignments-communication.service';

@Component({
    selector: 'app-assignment-communication-feedback-modal',
    templateUrl: './assignment-communication-feedback-modal.component.html',
    styleUrl: './assignment-communication-feedback-modal.component.scss'
})
export class AssignmentCommunicationFeedbackModalComponent implements OnInit {
    isLoading: boolean = false;
    assignmentId!: number;

    assignmentCommunicationFeedbackModel!: AssignmentCommunicationFeedbackPostModel;
    feedbackForm!: FormGroup;

    admins: SportDisciplineLeaderModel[] | null = null;

    feedbackSubject: string | null = null;

    constructor(
        protected assignmentCommunicationStateService: AssignmentsCommunicationStateService,
        private formBuilder: FormBuilder,
        private bsModalRef: BsModalRef,
        private assignmentCommunicationService: AssignmentsCommunicationService,
        private authService: UserAuthorizationService,
        private toasterService: SharedToasterService,
        protected assignmentDetailsStateService: AssignmentDetailsStateService
    ) { }

    ngOnInit(): void {
        this.loadData();
        this.initForm();
        this.subscribeToEvents();
    }

    get sender(): ApplicationUser | null {
        return this.authService.user;
    }

    public onSubmit(): void {
        if (!this.feedbackForm.valid) return;
        if (this.feedbackSubject == null) return;

        this.sendAssignmentCommunicationFeedback();
    }

    private sendAssignmentCommunicationFeedback(): void {
        if (this.feedbackSubject == null) return;
        this.isLoading = true;

        this.assignmentCommunicationFeedbackModel = {
            subject: this.feedbackSubject,
            feedback: this.feedbackForm.value.feedback,
            isSendCopyActive: this.feedbackForm.value.isSendCopy,
        };

        this.assignmentCommunicationService.sendAssignmentCommunicationFeedback(this.assignmentId, this.assignmentCommunicationFeedbackModel)
            .subscribe({
                next: (response) => {
                    this.toasterService.showGeneralEmailSendingSuccess();
                    this.bsModalRef.hide();
                },
                error: (error) => {
                    this.isLoading = false;
                    this.toasterService.showGeneralEmailSendingError();
                }
            });
    }

    private initForm(): void {
        this.feedbackForm = this.formBuilder.group({
            isSendCopy: [false],
            feedback: ['', Validators.required]
        });
    }

    private loadData(): void {
        this.assignmentCommunicationService.getDisciplineLeaderContacts(this.assignmentId)
            .subscribe({
                next: (results) => {
                    this.admins = results;
                },
                error: (error) => {
                    this.toasterService.showGeneralDataLoadingError();
                }
            });
    }

    private subscribeToEvents() {
        this.assignmentDetailsStateService.assignmentDetails.subscribe({
            next: (results) => {
                if (results == null || results == undefined) return;
                this.feedbackSubject = `${results.sportName} ${results.number} – Feedback via Staff-Tool`;
            },
        })
    }

}
